export const SHOW_SIDE_BAR = "SHOW_SIDE_BAR";
export const HIDE_SIDE_BAR = "HIDE_SIDE_BAR";


export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";

export const FORGETPASSWORD_REQUEST = "FORGETPASSWORD_REQUEST";
export const FORGETPASSWORD_FAIL = "FORGETPASSWORD_FAIL";
export const FORGETPASSWORD_SUCCESS = "FORGETPASSWORD_SUCCESS";

export const CHANAGEPASSWORD_REQUEST = "CHANAGEPASSWORD_REQUEST";
export const CHANAGEPASSWORD_FAIL = "CHANAGEPASSWORD_FAIL";
export const CHANAGEPASSWORD_SUCCESS = "CHANAGEPASSWORD_SUCCESS";

export const NEW_PASSWORD_REQUEST = "NEW_PASSWORD_REQUEST";
export const NEW_PASSWORD_FAIL = "NEW_PASSWORD_FAIL";
export const NEW_PASSWORD_SUCCESS = "NEW_PASSWORD_SUCCESS";

export const HIDE_MODAL = "HIDE_MODAL";
export const SHOW_MODAL = "SHOW_MODAL";

export const HIDE_EDIT_PROFILE_MODAL = "HIDE_EDIT_PROFILE_MODAL";
export const SHOW_EDIT_PROFILE_MODAL = "SHOW_EDIT_PROFILE_MODAL";

export const EDIT_PASSWORD_REQUEST = "EDIT_PASSWORD_REQUEST";
export const EDIT_PASSWORD_SUCCESS = "EDIT_PASSWORD_SUCCESS";
export const EDIT_PASSWORD_FAIL = "EDIT_PASSWORD_FAIL";

export const GET_USER_DETAIL_REQUEST = "GET_USER_DETAIL_REQUEST";
export const GET_USER_DETAIL_SUCCESS = "GET_USER_DETAIL_SUCCESS";
export const GET_USER_DETAIL_FAIL = "GET_USER_DETAIL_FAIL";

export const VERIFIED_USER_LISTING_REQUEST  = "VERIFIED_USER_LISTING_REQUEST";
export const VERIFIED_USER_LISTING_SUCCESS  = "VERIFIED_USER_LISTING_SUCCESS";
export const VERIFIED_USER_LISTING_UPDATE_USER_STATUS  = "VERIFIED_USER_LISTING_UPDATE_USER_STATUS";
export const VERIFIED_USER_PHONE  = "VERIFIED_USER_PHONE";
export const VERIFIED_USER_EMAIL  = "VERIFIED_USER_EMAIL";

export const VERIFIED_USER_LISTING_FAIL  = "VERIFIED_USER_LISTING_FAIL";

export const DEALER_LISTING_REQUEST  = "DEALER_LISTING_REQUEST";
export const DEALER_LISTING_SUCCESS  = "DEALER_LISTING_SUCCESS";
export const DEALER_LISTING_UPDATE_USER_STATUS  = "DEALER_LISTING_UPDATE_USER_STATUS";
export const DEALER_PHONE  = "DEALER_PHONE";
export const DEALER_LISTING_FAIL  = "DEALER_LISTING_FAIL";
export const VERIFIED_DEALER_EMAIL  = "VERIFIED_DEALER_EMAIL";

export const SHOW_ADD_DEALER_MODAL = "SHOW_ADD_DEALER_MODAL";
export const HIDE_ADD_DEALER_MODAL = "HIDE_ADD_DEALER_MODAL";